import { withSentryReactRouterV6Routing } from "@sentry/react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { CollectClient } from "@tree-company/collect-js-client";
import { ThemeSurveyWrapper } from "./views/theme_survey";
import { ChooseTheme } from "./views/choose_theme";
import translate from "./locales";
import { NextTheme } from "./views/next_theme";
import logo from "./assets/images/logo_diepenbeek.png";
import logoTree from "./assets/images/logo_tree.png";
import { useEffect } from "react";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

let collectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (collectorURL === undefined && import.meta.env.DEV) {
  collectorURL = "http://localhost:3000";
}

export const client = new CollectClient({
  url: collectorURL,
  projectKey: import.meta.env.VITE_COLLECTOR_KEY,
});

export default function App() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to the top if the page changes
    window.scrollTo({ top: 0, left: 0 });
  }, [location]);

  return (
    <>
      <SentryRoutes>
        <Route path="/" element={<ChooseTheme />} />
        <Route path="/next" element={<NextTheme apiClient={client} />} />
        <Route
          path="/:theme"
          element={<ThemeSurveyWrapper apiClient={client} />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </SentryRoutes>
      <footer className="footer">
        <div className="footer__top">
          <a
            href={translate(["general", "bpart_url"])}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={logo}
              alt={translate(["general", "logo_alt"])}
              className="footer__logo"
            />
          </a>
          <a href="https://www.treecompany.be" target="_blank" rel="noreferrer">
            <img
              src={logoTree}
              alt={translate(["general", "logo_tree_alt"])}
              className="footer__logo"
            />
          </a>
        </div>
        <div className="footer__bottom">
          <a
            href={translate(["general", "privacy", "link"])}
            className="footer__link"
          >
            {translate(["general", "privacy", "text"])}
          </a>
        </div>
      </footer>
    </>
  );
}
